import React, { useState, useEffect, useContext } from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd';
import MasterPage from '@components/MasterPage';
import Button from '@components/Button';
import {IProps, IState} from './types';
import * as S from './styles';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import WarningScreen from '@components/WarningScreen';
import C from '@assets/themes/colors';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { BrandsContext, BrandsProvider } from '@utils/DOIgnition/BrandsContext';
import Header from './components/Header';
import BrandList from './components/BrandList';
import BrandDetail from './components/BrandDetail';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { fetchBrands } from '@state/brands/actions';
import { getdeletedBrand } from '@state/brands/selectors';
import { getLabelsFromSection } from '@utils/brand';
import AddColor from './components/BrandDetail/AddElement/AddColor';
import { IUserType } from '@state/auth/types';
import SelectOrganization from './components/BrandDetail/SelectOrganization';
import ComboBox from '@components/ComboBox';
import { getDealerOrganizationsArray } from "@utils/DOIgnition/utils";
import { TransitionGroup } from 'react-transition-group';
import { fetchIndustries } from '@state/industries/utils';

const BrandLibrary:React.FC<IProps> = (props, state: IState) => {
    const [addBranLibrary, setAddBranLibrary] = useState<boolean>(false);
    const [organization, setOrganization] = useState<string|undefined>(undefined);
    const authContext = useContext(AuthContext);
    const{  searchSelectedAll, allFilters, getFilterQuery, addUpdateBrand, getQuerySearch, sortByQuery,
            brandDetail, setBrandDetail, viewAll, brandAction, setBrandAction } = useContext(BrandsContext);

    const hasPermissions = authContext.userData && authContext.userData.profile && (authContext.userData.profile.role === IUserType.ADMIN || (authContext.userData.profile.role === IUserType.DEALER_USER && authContext.dsPermissions?.includes("BRAND_LIBRARY")));
    const dealerUserData = authContext && authContext.userData?authContext.userData.profile:undefined;
    const dispatch = useDispatch();
    const history = useHistory(); 
    

    const addUpdateResponse = useSelector(selectors.brands.getAddUpdateBrand);
    const getDeletedResponse = useSelector(selectors.brands.getdeletedBrand);

    const [noAdminDetected, setNoAdminDetected] = useState(false);
    
    useEffect(() => {
      if (brandDetail?.open) setOrganization(undefined);
    }, [brandDetail?.open])

    useEffect(() => {
      if (!hasPermissions) {
        handleWarningScreen(
          true, "Unauthorized Page",
          `Please try to access Design Studio from a valid link in accordance with your user permissions. `,
          "", () => {history.push({pathname: '/'})}, "OKAY", "Unauthorized Page", []
        );
        setNoAdminDetected(true);
      }
    }, [])

    const fetchBrands = (option: string, length: number) => {      
      const query = createQuery(option, length);
      return new Promise((resolve, reject) => {
        dispatch(actions.brands.fetchBrands(query, (result, error) => {
          if (error) reject(error)
          else resolve(result)
        }))
      });
    }
 
    const createQuery=(option: string, length: number)=>{
      var finalQuery = "";
      const userData = {
        email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
        name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
      };
            
      let status = ` c.status='ACTIVE'`;
      let filters = loadingBrands===false ? getFilterQuery() : '';
      let search = loadingBrands===false ? getQuerySearch() : '';
      let orderBy = sortByQuery!=='' ? `orderby=${sortByQuery}` : 'orderby=c.formatName';
  
      if (option === "all") {
        var finalQuery = `?filter= ${status} ${filters} ${search}&${orderBy}&start=${length - 20}&pagelength=20`;      
      } else if (option === "names") {
        finalQuery = `?filter= c.name LIKE "%untitled%" ${status}&${orderBy}&start=0&pagelength=20`;
      }
      
      if (dealerUserData?.role==='DealerUser' &&  dealerUserData["dealeron.dealerorganization"]!= undefined &&  dealerUserData["dealeron.dealerorganization"]!=null) {      
        finalQuery += '&organizations=' + dealerUserData["dealeron.dealerorganization"].toString();
      }

      if (dealerUserData?.role) finalQuery += '&role=' + dealerUserData?.role;
      finalQuery += '&useremail=' + userData.email;

      finalQuery = encodeURI(finalQuery);
      return finalQuery;
    }

    const [isLoading, setIsLoading] = useState(true);
    const [currentBrands, setCurrentBrands] = useState(state.currentBrands);  
    const [globalBrands, setGlobalBrands] = useState(state.globalBrands);
    const [hasMore, setHasmore] = useState(state.hasMore);    
    const [open, setOpen] = useState(false);
    const [warningOptions, setWarningOptions] = useState({
      title: '',
      subtitle: '',
      actionTitle: '',
      actionFunction: () => {},
      closeActionTitle: '',
      errorNote: '',
      errorArguments: [],
    });
    const [selectedBrands, setSelectedBrands] = useState([] as any);
    let loadingBrands = false;

    const handleWarningScreen = (openValue:boolean, title:string, subtitle:string, actionTitle:string, actionFunction:any, closeActionTitle:string, errorNote:string, errorArguments: any) => {
      setOpen(openValue);
      setWarningOptions({
        title: title,
        subtitle: subtitle,
        actionTitle: actionTitle,
        actionFunction: actionFunction,
        closeActionTitle: closeActionTitle,
        errorNote: errorNote,
        errorArguments: errorArguments,
      })
    }

    const loadMoreBrands = async (index: number|undefined) => {
      
      var validIndex = index ??0;
      var newBrands: any = [];
      try {
  
        let lenght = globalBrands[validIndex].length;
        
        if (searchSelectedAll || allFilters.length>0 || sortByQuery!=="") lenght=currentBrands.length;
          
        if (searchSelectedAll) 
          newBrands = await fetchBrands("all-search", lenght + 20);
        else if (validIndex === 0) 
          newBrands = await fetchBrands("all", lenght + 20);
          
        if (newBrands && newBrands.length > 0) {
          if (!searchSelectedAll && allFilters.length==0 && sortByQuery==="") {
            var newGlobalBrands: any[] = globalBrands;
            newGlobalBrands[validIndex] = [...newGlobalBrands[validIndex], ...newBrands];
            setCurrentBrands(newGlobalBrands[validIndex]);
            setGlobalBrands(newGlobalBrands);
          } else {
            setCurrentBrands([...currentBrands, ...newBrands]);
          }
        }
        if (newBrands.length !== 20) {
          setHasmore([
            ...hasMore.slice(0, validIndex),
            false,
            ...hasMore.slice(validIndex + 1)
          ]);
        }
      } catch(error) {
        console.error(error);
      }
    }
    const onActions = (item: any, action: string, folder?:number) => {
     
        /*if (action === "DUPLICATEEDIT") handleDuplicate(item);
        if (action === "FAVORITEDESIGN") handleFavorite(item);
        if (action === "DELETE") handleAskDelete(item);
        if (action === "SELECTEDDESIGNS") handleSelectedManyDesigns(item);
     */
    }

    const handleUploadItem = () => {
      setBrandAction({section: viewAll?.section ?? 'logos', action: "add", element: "new"});
    }

    const handleAddEditBrandLibrary = () => {
      if (dealerUserData?.role==='DealerUser' && dealerUserData["dealeron.dealerorganization"]) setAddBranLibrary(true);
      else setBrandDetail({open: true})
    }

    const handleUpdateOrganization =  (value: string) => {
      if (brandDetail?.brand!==null) {
        setOrganization(value);
        addUpdateBrand(undefined,undefined, undefined, undefined, {...brandDetail.brand, organization: value==='None' ? 'DealerUser': value });
      }
    }
    
    const canEditOrganization = () => {
      if (brandDetail?.open && !viewAll?.open && 
        dealerUserData?.role==='DealerUser' &&
        ((dealerUserData["dealeron.dealerorganization"] &&
        dealerUserData["dealeron.dealerorganization"].includes(brandDetail?.brand?.organization))
        || brandDetail?.brand?.organization===null 
        || brandDetail?.brand?.organization==="DealerUser" || brandDetail?.organization)) 
        return true;
      return false;
    }
    
    const getOrganization = () => {
      if (brandDetail?.brand?.organization==='DealerUser') return undefined;
      else if(organization??brandDetail?.brand?.organization) return organization??brandDetail?.brand?.organization;
      else return (brandDetail?.organization && brandDetail?.organization!=='DealerUser') ? brandDetail?.organization:undefined;
    }

    const isEnabledOrganization = () =>{

      if (brandDetail.brand && brandDetail.brand.createdBy)
      return brandDetail?.open && !viewAll?.open &&
      dealerUserData?.role==='DealerUser' &&  dealerUserData.email == brandDetail.brand.createdBy.email 

      return true;
    }


    useEffect(() => {
      const run = async () => {
        var newGlobalBrands: any[] = Array(2).fill([]);
        var newHasMore: any = Array(2).fill(true);        
        try {
          const AllBrands: any = await fetchBrands("all", 20);          
          await fetchIndustries(dispatch);
          newGlobalBrands[0] = AllBrands;
          if (AllBrands?.length !== 20) newHasMore[0] = false;
          setHasmore(newHasMore);
          setGlobalBrands(newGlobalBrands);
          setCurrentBrands(AllBrands);          
          setIsLoading(false);
        } catch(error) {
          console.error(error);
        }
      }
      run();
    }, [])

    useEffect(() => {
      if ((addUpdateResponse || getDeletedResponse) && currentBrands && globalBrands) {
        const run = async () => {
          var newGlobalBrands: any[] = Array(2).fill([]);
          var newHasMore: any = Array(2).fill(true);        
          try {
            const AllBrands: any = await fetchBrands("all", 20);          
            newGlobalBrands[0] = AllBrands;
            if (AllBrands?.length !== 20) newHasMore[0] = false;
            setHasmore(newHasMore);
            setGlobalBrands(newGlobalBrands);
            setCurrentBrands(AllBrands);          
            setIsLoading(false);
          } catch(error) {
            console.error(error);
          }
        }
        run();
      }
    }, [addUpdateResponse, getDeletedResponse])
   

    return (
      <S.Root>
        <WarningScreen
          open={open}
          setOpen={setOpen}
          options={warningOptions}
        />
         <MasterPage
        pageIndex={4}
        newHeight={300}
        newTitle={viewAll?.pageTitle??undefined}
        renderAction={() => (
          <S.Header> 
            {!brandDetail?.open &&        
              <Button
                  icon="add" 
                  label="ADD BRAND"
                  style={{zIndex: 10,hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", width: 153, height: 36, boxSizing: 'border-box'}}
                  labelStyle={{color: "white", fontWeight: '500'}}
                  onClick={()=>handleAddEditBrandLibrary()}
              />}
            { canEditOrganization() && 
            <S.OrganizationContainer>
              <S.OrganizationTitle>Organization</S.OrganizationTitle>
              <ComboBox 
                  id="organization"
                  placeholder="Select"
                  options={dealerUserData["dealeron.dealerorganization"]? ['None', ...getDealerOrganizationsArray(dealerUserData['dealeron.dealerorganization'])]:[]}
                  required={false}
                  disabled={!isEnabledOrganization()}
                  position={"bottom"}
                  chooseOption={(id:string, value:string) => handleUpdateOrganization(value)}
                  value={getOrganization()}
                  containerStyle={{
                      padding: "0px",
                      width: "256px",
                      zIndex: "250"
                  }}
                  optionContainerStyle={{top: '55px'}}
              />
            </S.OrganizationContainer>}
            { viewAll?.open &&
              <Button
                  icon="add" 
                  label={`ADD ${getLabelsFromSection(viewAll?.section ?? 'logos').toUpperCase()}`}
                  style={{zIndex: 10, hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", height: 36, boxSizing: 'border-box'}}
                  labelStyle={{color: "white", fontWeight: '500'}}
                  onClick={handleUploadItem}
              />
            }
            
          </S.Header>
      )}
      >
        <S.AbsoluteContentContainer>
          {
          //<Header/>
          }
          <DndProvider backend={HTML5Backend}>
            <S.ContentContainer>  
              {brandDetail?.open ? 
                  <BrandDetail handleWarningScreen={handleWarningScreen}/>           
                : 
                  <BrandList
                    isLoading={isLoading}
                    //hasNoBrands={currentBrands && currentBrands.length==0} 
                    hasNoBrands={false} 
                    currentBrands={currentBrands}
                    hasMore={hasMore?.length > 0 ? hasMore[0] : false}
                    loadMoreBrands={loadMoreBrands}
                    onActions={onActions}
                    dealerUser={dealerUserData?.role==='DealerUser'}
                  />
              }
            </S.ContentContainer>                    
            </DndProvider>
        </S.AbsoluteContentContainer>
        { (brandAction?.action === "add" && brandAction?.section === "colors" && viewAll?.section === "colors") && 
          <AddColor
            position={{top: `22px`, right: `200px`}}
          />
        }
        {addBranLibrary && <SelectOrganization open={addBranLibrary} setOpen={setAddBranLibrary}/>}
      </MasterPage>
      </S.Root>
    );
}

export default BrandLibrary;